module.exports = {
  serviceUrl: "/api/",
  noteForgotPassword:
    "If you do not remember your user name then please contact Ameya adminsitrator",
  noteCustSupp:
    "Please enter the complete Company Name, once registered the PAN Number and Company Name cannot be modified.",
  contactNameNote:
    "Please type Contact Name added in Contacts list to get list of Contacts to assign contact person for this address.",
  bankDetNote:
    "Please type Bank Name added in Bank list to get list of Banks to assign Bank to this address.",
  sitekey: "6Ld6D6sZAAAAAE5nycdgZILuZ0DjTPP-WUGIotxs",
  // sitekey: "6LcXWasZAAAAAEMZo9z6bJk7nUWKqUEjsGBtq63F",

  regex: /^[0-9a-zA-Z(\-)_ ]+$/,
};
